module.exports = __webpack_public_path__ + "img/NormalSeat_SnowWhite.92a61625.png";